import Header from "../../components/Header/Header";
import { Images } from "../../assets/assets";
import Footer from "../../components/Footer/Footer";

import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import Retailers from "../../components/Modal/Retailers/Retailers";
import { useState } from "react";


const GasRefillsPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };


  return (
    <>
      <Header
        desktopHeight="70vh"
        title="Spare Cylinder"
        subTitle=""
        backgroundImg={
          "http://res.cloudinary.com/brabenjos/image/upload/v1723093154/sodastream/1723093153077.png"
        }
        textBackground="Spare Cylinder"
      />
      <div className="bg-white">
        <section className="flex flex-col md:flex-row bg-[#efebe4]">
          <div className="flex-1 p-4 m-2 rounded mt-[7%]">
            <h1
              className="box-border text-[rgb(0,93,110)] block  text-2xl font-semibold 
      leading-[38.4px] text-start">
              Get a Spare Cylinder
            </h1>
            <p
              className="box-border text-[rgb(0,34,56)] block  text-sm font-normal leading-normal mb-[15px]
     text-start">
              Keep a backup cylinder and never run out of bubbles. Each cylinder
              makes up to 15 gallons of fresh sparkling water.
            </p>

            <section className="flex flex-col md:flex-row p-4  justify-start">
              <div className="flex-1 ">
                <Retailers
                  showModal={showModal}
                  isModalVisible={isModalVisible}
                  setIsModalVisible={setIsModalVisible}
                  buttonClassName="w-[200px] h-[40px] 
                   text-[16px] text-white font-bold rounded-full bg-[#75A7AD] flex items-center justify-center focus:outline-none"
                  buttonTitleClassName="text-[14px] leading-[24px]
                   font 
                  font-bold text-white
                      sm:text-[16px] sm:leading-[19px]"
                />
              </div>
              <div className="flex gap-1 items-center justify-start pt-[20px] text-[rgb(0,93,110)]">
                <p className="text-[18px] font-bold flex items-center">
                  Find A Store
                  <span className="font-bold">
                    <BiChevronRight fontSize={30} />
                  </span>
                </p>
              </div>
            </section>
          </div>
          <div className="flex-1 p-4 m-2 rounded max-w-[80%] mx-auto">
            <img
              src="http://res.cloudinary.com/brabenjos/image/upload/v1723814138/sodastream/1723814137820.webp"
              alt=""
              className="w-full h-auto "
            />

            <p className="box-border text-[#8b9195] text-xs font-normal h-[18px] leading-normal text-left mt-7">
              *Depending on the level of carbonation and type of SodaStream
              sparkling water maker.
            </p>
          </div>
        </section>
        <section className="bg-[#efebe4]">
          <div className="bg-[#75A7AD] h-auto  flex flex-col md:flex-row justify-center items-center pb-3">
            <div className="p-4 m-2 rounded ">
              <img
                src="https://sodastream.com/cdn/shop/files/icon-healthier_11.png?v=1672146967&width=68"
                alt=""
              />
            </div>
            <div className="flex flex-col items-center md:items-start">
              <p className="text-[14px] block font-bold rounded-full text-white items-center text-start hover:bg-[#080A40] focus:outline-none">
                Our Pro Tip:
              </p>
              <p className="box-border p-2 text-white block text-sm font-normal leading-normal text-start">
                Exchange your empty cylinder for a full one and pay only for the
                refill. Each cylinder makes up to 15 gallons of fresh sparkling
                water.
              </p>
            </div>
          </div>

          {/* refill now */}

          <div>
            <h1 className="box-border text-center text-[rgb(0,34,56)] block text-2xl font-semibold h-[38px] leading-[38.4px] mb-1  pt-[75px]">
              Getting a refill or a back up?
            </h1>
            <p className="box-border pt-[30px] text-center text-[rgb(0,34,56)] block text-[16px] font-normal leading-[30.72px]">
              Find the best option for you
            </p>
          </div>

          <section className="flex flex-col md:flex-row  space-y-4 md:space-y-0 md:space-x-4">
            <div className=" text-white p-4 flex-1">
              {/*  */}

              {/*  */}
              <section className="">
                <div className="flex flex-wrap">
                  <div className=" text-white p-4 flex-1 w-[50%] hidden md:block">
                    {/* Contenu du premier élément */}
                  </div>
                  <div className=" text-white  flex-1 w-[100%] md:w-[50%]">
                    <div className=" rounded-lg overflow-hidden">
                      <div className="w-full ">
                        <img
                          src={Images.ExchangeBottleSpareImg}
                          alt="order spare"
                          className="w-full h-[180px] object-cover rounded-[10px]"
                        />
                      </div>
                      <div className="pl-4 mt-3">
                        <h1
                          className="box-border text-left text-[rgb(0,34,56)] text-[18px]
    block  text-2xl font-semibold h-auto leading-[38.4px]">
                          Exchange Empty Cylinders
                        </h1>
                        <h2
                          className="text-[16px] box-border text-[rgb(0,34,56)] block  text-sm font-normal 
   leading-normal 
   
     text-start">
                          {
                            "Return your empty cylinders for full ones and pay only for the refill"
                          }
                        </h2>
                        <Link to={"/refill"}>
                          <button
                            className="bg-transparent text-[#005D6E] w-full max-w-[150px] border-[2px] border-[#75A7AD] h-[35px]
           text-[16px] font-semibold
             rounded-full flex items-center 
             justify-center hover:bg-[#005D6E] hover:text-white focus:outline-none mt-4 px-4">
                            Refill Now
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="bg-[] text-white p-4 flex-1">
              <section
                className="flex flex-col md:flex-row  
            space-y-4 md:space-y-0 md:space-x-4">
                <div className="flex flex-wrap">
                  <div className="text-white  flex-1 w-[100%] md:w-[50%]">
                    <div className="rounded-lg overflow-hidden">
                      <img
                        src={
                          "http://res.cloudinary.com/brabenjos/image/upload/v1723698373/sodastream/1723698373210.webp"
                        }
                        alt={""}
                        className="w-full h-auto object-cover rounded-[10px]"
                      />
                      <div className="pl-4">
                        <h1
                          className="box-border text-left text-[rgb(0,34,56)] text-[18px]
    block  text-2xl font-semibold h-auto leading-[38.4px] mb-1  
    pt-[9px]">
                          Order a Spare
                        </h1>
                        <h2
                          className=" text-[16px] box-border text-[rgb(0,34,56)] block  text-sm 
   font-normal leading-normal 
     text-start">
                          {
                            "Buy a spare cylinder online and never run out of gas"
                          }
                        </h2>
                        <Link to="/spare">
                          <button
                            className="bg-transparent text-[#005D6E] w-full max-w-[150px] border-[2px] border-[#75A7AD] h-[35px]
           text-[16px] font-semibold
             rounded-full flex items-center 
             justify-center hover:bg-[#005D6E] hover:text-white focus:outline-none mt-4 px-4">
                            Buy a spare
                          </button>
                        </Link>
                        {/* <button className='w-[200px] h-[60px] 
        text-[16px] text-[#080A40] font-bold rounded-full flex items-center justify-center
        border border-[#080A40] hover:bg-[#080A40] hover:text-white focus:outline-none text-[16px]'>
  Buy a spare
</button> */}
                      </div>
                    </div>
                  </div>
                  <div className=" text-white p-4 flex-1 w-[50%] hidden md:block">
                    {/* Contenu du premier élément */}
                  </div>
                </div>
              </section>
            </div>
          </section>
        </section>

        {/*  */}

        <section>
          <div className="relative h-auto md:h-[400px] w-full bg-[#EEEAE5] p-20 md:px-40 px-10 flex flex-col-reverse md:flex-row justify-between items-center">
            <div className="md:basis-[50%] basis-[100%]">
              <div className="flex flex-col gap-4 items-start justify-center text-start md:w-2/3">
                <div className="basis-[50%] py-20 text-start flex flex-col gap-5">
                  <h2
                    className="text-[20px]  box-border text-[rgb(0,93,110)] block text-2xl font-semibold 
      leading-[38.4px] text-start">
                    Our gas cylinders
                  </h2>
                  <p
                    className="box-border text-sm font-normal leading-normal
     text-start">
                    Each sparkling water maker is compatible with a specific
                    cylinder: either the Classic screw-in system or the Quick
                    Connect system.
                  </p>
                </div>
              </div>
            </div>

            <div className="md:basis-[40%] basis-[100%] ">
              <img
                src={Images.CylinderUS}
                alt="cylunder img"
                className=" bottom-0 left-0 z-50"
                style={{ width: "70%" }}
              />
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default GasRefillsPage;
